<template>
  <user-mini-card
    ref="minicard"
    :username="username"
    :version="$store.state.version.remoteVersion"
    :name="user.profile.user.first_name"
    @cardClosed="closeMiniCard = false"
  >
    <div class="user-dropdown">
      <!-- <div class="user-section">
        <base-avatar
          :style="{ margin: '13px 74px 13px 74px' }"
          :size="72"
          :username="username"
          :inverse="adminOptions"
          :background-color="adminOptions ? '#000000' : undefined"
          rounded
        />

        <base-text
          v-if="user"
          class="user-header"
          muted
        >
          {{ name }}
        </base-text>

        <base-text
          v-if="user"
          class="email-header"
          size="xs"
          muted
          light
        >
          <base-text
            size="xs"
            style="font-size:12px; font-weight:300; line-height:14px;"
          >
            {{ adminOptions ? "Admin" : "Stylist" }}
          </base-text>
        </base-text>
      </div> -->

      <template>
        <base-cell
          v-for="adminMode in userModes"
          v-show="adminMode !== adminOptions"
          :key="`adminMode_selector_${adminMode}`"
          class="user-details-section px-2 user-details-section__stylist"
        >
          <div class="user-details-section__body" style="flex-direction: column; ">
            <div
              v-if="isStylist"
              class="card_item"
              style="display:flex; width:285px"
              :class="!adminMode ? 'item_nonactive' : 'item_active'"
              @click="showAdminOptions(adminMode)"
            >
              <base-avatar
                class="mini-avatar"
                :size="31"
                :username="username"
                :inverse="false"
                :background-color="undefined"
                rounded
              />
              <div class="user-email">
                <base-text
                  v-if="user"
                  class="user"
                  muted
                  block
                >
                  {{ fullName }}
                </base-text>
                <base-text
                  size="xs"
                  style="color:rgba(51, 51, 51, 0.8); font-size:12px; font-weight:300; line-height:14px;"
                >
                  Stylist
                </base-text>
              </div>
              <div v-if="adminMode" style="margin-left: auto;">
                <base-icon icon="check" />
              </div>
            </div>
          </div>
        </base-cell>
        <base-cell
          v-for="adminMode in userModes"
          v-show="adminMode !== adminOptions"
          :key="`adminMode_selector_${adminMode}`"
          class="user-details-section px-2 user-details-section__admin"
        >
          <div class="user-details-section__body" style="flex-direction: column; ">
            <div
              v-if="isManager"
              class="card_item"
              style="display:flex; width:285px"
              :class="adminMode ? 'item_nonactive' : 'item_active'"
              @click="showAdminOptions(adminMode)"
            >
              <base-avatar
                class="mini-avatar"
                :size="31"
                :username="username"
                background-color="#000000"
                :inverse="true"
                rounded
              />
              <div class="user-email">
                <base-text
                  v-if="user"
                  class="user"
                  muted
                  block
                >
                  {{ fullName }}
                </base-text>
                <base-text
                  size="xs"
                  style="color:rgba(51, 51, 51, 0.8); font-size:12px; font-weight:300; line-height:14px;"
                >
                  Admin
                </base-text>
              </div>
              <div v-if="!adminMode" style="margin-left: auto;">
                <base-icon icon="check" />
              </div>
            </div>
          </div>
        </base-cell>
      </template>

      <template v-if="isSuperuser">
        <base-cell
          class="px-2"
          style="border-bottom: solid 0.5px rgba(128, 128, 128, 0.5)"
        >
          <div
            class="text-center w-100 cursor-pointer"
            @click="$emit('goBackToAccount')"
          >
            <base-text
              class="user"
              muted
            >
              Go back to my account
            </base-text>
          </div>
        </base-cell>
      </template>

      <div v-if="isSuperuser" class="row logout">
        <base-button @click="$emit('goto', 'login')">
          logout
        </base-button>
      </div>

      <div v-else>
        <base-cell
          class="user-details-section px-2 user-details-section__admin"
          @click="$emit('goto', 'login')"
        >
          <div class="row logout_notsu">
            <base-icon icon="sign-out" style="padding-right:20px;" />
            <base-text style="font-family: 'SilkaLight';font-size: 14px; line-height: 135%;">
              Log out
            </base-text>
            <!-- <base-button @click="$emit('goto', 'login')">
              <base-icon icon="sign-out" style="padding-right:23px;" /> Log out
            </base-button> -->
          </div>
        </base-cell>
      </div>
    </div>
  </user-mini-card>
</template>

<script>
export default {
  name: 'MainNavigationMiniCard',
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    adminOptions: {
      type: Boolean,
      default: false,
    },
    isSuperuser: {
      type: Boolean,
      default: false,
    },
    isStylist: {
      type: Boolean,
      default: false,
    },
    isManager: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    fullName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      closeMiniCard: false,
    };
  },
  computed: {
    /** Superuser navigation only has 'stylist' mode enabled */
    userModes() {
      return [false, ...(this.$store.getters['account/isSuperuser'] ? [] : [true])];
    },
  },
  methods: {
    showAdminOptions(adminMode) {
      // ⭐️ Clean Customers State ⭐️ //
      this.$store.dispatch('customers/reset');

      this.closeMiniCard = true;
      this.$nextTick().then(() => {
        this.$emit('showAdminOptions', adminMode);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-label {
  color: #aaaaaa;
  font-weight: 300;
  text-transform: uppercase;
  padding: 0;
  line-height: 22px;
  text-align: right;
  letter-spacing: -0.15px;
}
.user-mini-card__options {
  width: 140px !important;

  .user-dropdown {
    width: 100%;
    margin-top: 5px;

    .user-section {
      align-items: center;
      text-align: center;
      // box-shadow: 0 0.25px 0 #333;
      padding-bottom: 15px;

      .user-header {
        color: #333333;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0.25px;
      }
      .email-header {
        font-size: 9px;
        line-height: 11px;
        letter-spacing: 0.25px;
      }
      .menu-rule {
        width: 260px;
      }
    }

    .user-details-section {
      &__admin:hover{
        background: #F0F0F0;
      }
      &__stylist:hover{
        background: #F0F0F0;
      }
      &__body {
        width: 100%;
        display: flex;
        justify-items: center;
        align-items: center;
      }
      .row.col-12 {
        .col-1.avatar {
          padding: 0;
          margin-top: 1px;
        }
      }
      .mini-avatar {
        margin-right: 5px;
      }
      .user-email {
        padding: 0 0 0 6px;
        font-weight: 300;
        .user {
          color: #333333;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: -0.15px;
        }
        .email {
          line-height: 10px;
        }
      }
    }

    .logout {
      padding-top: 20px;
      padding-bottom: 20px;
      display: flex;
      justify-content : center;
      align-items : center;

      .base-button {
        height: 26px;
        width: 98px;
        font-size: 11px;
        letter-spacing: 0.25px;
        line-height: 1;
        border-width: 0.75px;
        border: 0.75px solid #333333;;
        border-radius: 5px !important;
      }
    }
    .logout_notsu {
      width: 315px;
      margin-left: unset !important;
      padding: 15px 25px 20px ;
      justify-content : start;

      .base-button {
        padding: unset;
        font-family: 'SilkaLight';
        font-size: 14px;
        color: #1B1B1B;
        letter-spacing: 0.25px;
        line-height: 1;
        border: unset !important;
        border-radius: unset !important;
        background: transparent !important;
      }
    }
    .logout_notsu:hover {
      background: #F0F0F0;
    }
  }
}

.admin-avatar {
  background-color: #666;
  color: white;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &__img {
    transform: translateY(-2px);
  }
  &__icon {
    margin-bottom: -5px;
    transform: translateX(2px);
  }

  &__text {
    text-transform: uppercase;
    font-size: 0.6rem;
  }
}
.card_item{
  display: flex;
  align-self: start;
  margin: 10px 0px 10px 16px;
}
::v-deep .base-cell{ // remove border on top cell
  border-top: unset !important;
  padding: unset !important;
}
.item_active{
  pointer-events: none;
}
.item_nonactive{
  cursor: pointer;
}
</style>
